import {NgModule} from "@angular/core";
import {ProtokollerMedBehandlingerListingKomponentAvhengigheter} from "web-ng2/moduler/plan/komponenter/protokoller-med-behandlinger-listing/protokoller-med-behandlinger-listing";

@NgModule({
    providers: [
        ProtokollerMedBehandlingerListingKomponentAvhengigheter
    ]
})
export class PlanModul {

}
